<template>
  <div
    class="wrap"
    :style="{
      background:
        list.lives_will.length < 1 &&
        list.lives_ed.length < 1 &&
        list.lives_ing.length < 1
          ? '#FFFFFF'
          : '',
    }"
  >
    <router-link :to="{ name: 'Live' }">
      <div class="search">
        <img src="../../assets/images/new_log.png" alt="" />
        <!--<div>-->
        <!--<input type="text" placeholder="Search" v-model="title">-->
        <!--<div @click="toMore(type,1)">-->
        <!--<img src="../../assets/images/search.png" alt="">-->
        <!--</div>-->
        <!--</div>-->
      </div>
    </router-link>
    <div class="container" v-if="list">
      <div class="type_title" v-if="list.lives_ing.length > 0">
        <span class="live_type" style="color: #a5c241">直播中</span>
      </div>
      <div
        class="container_item"
        v-for="(item, index) in list.lives_ing"
        :key="'livesing' + index"
      >
        <p class="item_title">
          <!--<span class="title_name">-->
          <!--<span>{{item.egName}}</span>-->
          <!--</span>-->
          <span class="title_time">{{ getTimes(item.lDt) }}</span>
        </p>
        <div class="con" @click="toDetails(item.lId)">
          <img
            class="con_images"
            :src="item.lPicUrl"
            alt=""
            v-if="item.lPicUrl"
          />
          <img
            class="con_images"
            src="../../assets/images/default.png"
            alt=""
            v-else
          />
          <div class="con_right">
            <p class="con_title">{{ item.lTitle }}</p>
            <div>
              <p class="con_author">{{ item.lSpeaker }}</p>
              <p class="con_org">{{ item.lOrg }}</p>
            </div>
          </div>
        </div>
      </div>

      <div class="type_title" v-if="list.lives_will.length > 0">
        <span class="live_type" style="color: #ffb441">即将直播</span>
      </div>
      <div
        class="container_item"
        v-for="(item, index) in list.lives_will"
        :key="'liveswill' + index"
      >
        <p class="item_title">
          <!--<span class="title_name">-->
          <!--<span>{{item.group.egName}}频道</span>-->
          <!--</span>-->
          <span class="title_time">{{ getTimes(item.lDt) }}</span>
        </p>
        <div
          class="con"
          @click="toDetails(item.lId)"
          style="border-bottom: 1px solid #e6e6e6"
        >
          <img
            class="con_images"
            :src="item.lPicUrl"
            alt=""
            v-if="item.lPicUrl"
          />
          <img
            class="con_images"
            src="../../assets/images/default.png"
            alt=""
            v-else
          />
          <div class="con_right">
            <p class="con_title">{{ item.lTitle }}</p>
            <div>
              <p class="con_author">{{ item.lSpeaker }}</p>
              <p class="con_org">{{ item.lOrg }}</p>
            </div>
          </div>
        </div>
        <div class="last">
          <span>预约人数：{{ item.lAppointNum }}人</span>
          <button
            class="footer_yybm"
            @click="signUp(item.lIsAppoint, index, item.lId)"
            :style="{
              background: item.lIsAppoint == 1 ? '#999999' : '#FFB441',
            }"
          >
            {{ item.lIsAppoint == 1 ? "已预约" : "预约报名" }}
          </button>
        </div>
      </div>

      <div class="type_title" v-if="videos.length > 0">
        <!--list.lives_ed.length>0-->
        <span class="live_type">直播回顾</span>
      </div>
      <i-videolist :video_newest="videos" v-on:success="success"></i-videolist>

      <div
        v-if="
          list.lives_will.length < 1 &&
          videos.length < 1 &&
          list.lives_ing.length < 1
        "
        class="nothing"
      >
        <img src="../../assets/images/nonelist.png" alt="" />
        <div>暂无更多</div>
      </div>
    </div>
  </div>
</template>
<script>
import iBanner from "../container/banner";
import weui from "weui.js";
import iVideolist from "../container/videoList";
import loginService from "../../plugin/extendFn/loginService";
import { resolve } from "q";

export default {
  data() {
    return {
      imgList: [],
      list: {
        lives_will: [],
        lives_ing: [],
        lives_ed: [],
      },
      videos: [],
      uid: "",
      ra_wxUser: null,
    };
  },
  props: {},
  created() {
    this.$waiting.show(3);
  },
  methods: {
    Activity() {
      this.$router.push({
        name: "Activity",
      });
    },
    getData() {
      this.$postHttp("/live/student/list", {
        uid: this.ra_wxUser
          ? this.ra_wxUser.uId
            ? this.ra_wxUser.uId
            : ""
          : "",
        egId: this.$route.query.type,
      }).then((res) => {
        if (res.data.code == 0) {
          this.$waiting.hide();
          let data = res.data.value;
          this.list = data;
          console.log(data);
          // this.sing = data.lives_will.lIsAppoint==1?1:0;
          // alert(this.sing)
          // this.text = data.lives_will.lIsAppoint==1?'已预约':'预约报名';
          // this.lives_ing = data.lives_ing;
          this.imgList = data.pictures;
          // this.lives_will = data.lives_will;
          // this.lives_ed = data.lives_ed;
        }
      });

      let params = {
        type: this.$route.query.type,
      };
      this.$postHttp("/video/list/condition", params).then((res) => {
        // console.log(res);
        if (res.data.code == 0) {
          let data = res.data.list;
          console.log(data);
          this.videos = data;
        }
      });
    },
    getTimes(value) {
      return new Date(value).Format("yyyy.MM.dd hh:mm");
    },
    toDetails(id) {
      this.$router.push({
        name: "Details",
        query: { type: "live", liveId: id },
      });
    },
    async toVideoDetails(item) {
      // vId,item.vIsPublic
      if (this.$route.name == "Details") {
        if (item.vIsPublic == 0) {
          //非公开课 非公开只有会员可以看;
          // alert(this.ra_wxUser.uIsMember)
          if (
            this.ra_wxUser.uIsMember == 0 ||
            this.ra_wxUser.uIsMember == null ||
            this.ra_wxUser.uIsMember == ""
          ) {
            //不是会员
            bus.$emit("isstop", "stop");
            // setTimeout(()=>{
            //   this.ismember = true;
            // },200)
            this.ismember = true;
            this.$emit("listtomember", "yes");
          } else {
            this.$router.push({
              name: "Details",
              query: { type: "video", videoId: item.vId },
            });

            location.reload();
          }
        } else {
          //公开课
          this.$router.push({
            name: "Details",
            query: { type: "video", videoId: item.vId },
          });
          location.reload();
        }
      } else {
        if (item.vIsPublic == 0) {
          //非公开课 非公开只有会员可以看;
          // this.poster = true;
          // this.chimee.pause()
          //
          if (await loginService.isNotLogin()) {
            if (loginService.isWeixinBrowser()) {
              //在微信浏览器中
              this.login().then(() => {
                if (
                  this.ra_wxUser.uIsMember == 0 ||
                  this.ra_wxUser.uIsMember == null ||
                  this.ra_wxUser.uIsMember == ""
                ) {
                  //不是会员
                  this.ismember = true;
                  bus.$emit("isstop", "stop");
                } else {
                  this.$router.push({
                    name: "Details",
                    query: { type: "video", videoId: item.vId },
                  });
                }
              });
            }
          } else {
            if (
              this.ra_wxUser.uIsMember == 0 ||
              this.ra_wxUser.uIsMember == null ||
              this.ra_wxUser.uIsMember == ""
            ) {
              //不是会员
              this.ismember = true;
              bus.$emit("isstop", "stop");
            } else {
              this.$router.push({
                name: "Details",
                query: { type: "video", videoId: item.vId },
              });
            }
          }
        } else {
          //公开课
          this.$router.push({
            name: "Details",
            query: { type: "video", videoId: item.vId },
          });
        }
      }
    },
    async signUp(status, index, lid) {
      localStorage.setItem("userLiveId", lid);
      localStorage.setItem("usertype", 1);

      this.ra_wxUser = await loginService.getLoginUser();

      if (await loginService.isNotLogin()) {
        this.login();
      } else if (
        (this.ra_wxUser.uPhone == null ||
          this.ra_wxUser.uPhone == "" ||
          this.ra_wxUser.uPhone == "null" ||
          this.ra_wxUser.uPhone == undefined) &&
        (this.ra_wxUser.uMail == null ||
          this.ra_wxUser.uMail == "" ||
          this.ra_wxUser.uMail == "null" ||
          this.ra_wxUser.uMail == undefined)
      ) {
        this.$router.push({
          name: "Login",
        });
      } else if (this.ra_wxUser.uPhone || this.ra_wxUser.uMail) {
        if (status == 0) {
          this.$postHttp("/live/appointment", {
            uid: this.ra_wxUser
              ? this.ra_wxUser.uId
                ? this.ra_wxUser.uId
                : ""
              : "",
            lid: lid,
          }).then((res) => {
            if (res.data.code == 0) {
              // this.text = '已预约';
              // this.sing = 1;
              // this.list.lives_will[index].lIsAppoint.$set()
              this.$set(this.list.lives_will[index], "lIsAppoint", 1);
              this.$set(
                this.list.lives_will[index],
                "lAppointNum",
                res.data.num
              );
              //参数：要改的对象、要改的key 、要改的值
              this.toast("预约成功");
            } else {
              this.topTips("预约失败");
            }
          });
        } else {
          weui.dialog({
            content: "确定要取消预约吗？",
            className: "yors",
            buttons: [
              {
                label: "取消",
                type: "default",
                onClick: (res) => {
                  // alert('取消')
                },
              },
              {
                label: "确定",
                type: "primary",
                onClick: () => {
                  this.$postHttp("/live/appointment/cancel", {
                    uid: this.ra_wxUser
                      ? this.ra_wxUser.uId
                        ? this.ra_wxUser.uId
                        : ""
                      : "",
                    lid: lid,
                  }).then((res) => {
                    if (res.data.code == 0) {
                      this.$set(this.list.lives_will[index], "lIsAppoint", 0);
                      this.$set(
                        this.list.lives_will[index],
                        "lAppointNum",
                        res.data.num
                      );
                      this.toast("取消成功");
                    } else {
                      this.topTips("取消预约失败");
                    }
                  });
                },
              },
            ],
          });
        }
      }
    },
    login() {
      return new Promise((resolve, reject) => {
        loginService
          .login(this.$router)
          .then((loginUser) => {
            this.ra_wxUser = loginUser;
            this.getData();
            resolve(loginUser);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
  },
  computed: {},
  components: {
    iBanner,
    iVideolist,
  },
  async mounted() {
    this.ra_wxUser = await loginService.getLoginUser();

    document.body.scrollTop = document.documentElement.scrollTop = 0;

    this.getData();
  },
};
</script>
<style scoped lang="scss">
.search {
  height: 1.1rem;
  display: flex;
  align-items: center;
  padding: 0 0.3rem;
  box-sizing: border-box;
  background: #ffffff;
  > img {
    width: 2.79rem;
    height: 0.38rem;
  }
  > div {
    display: flex;
    width: 3.8rem;
    height: 0.7rem;
    border: 1px solid #dbdbdb;
    padding-left: 0.2rem;
    background: #ffffff;
    box-sizing: border-box;
    border-radius: 10px;
    margin-left: 0.32rem;

    input {
      width: 3rem;

      border: none;
      outline: none;
    }
    input::placeholder {
      color: #999999;
    }
    > div {
      width: 0.6rem;
      height: 0.68rem;
      border-top-right-radius: 10px;
      border-bottom-right-radius: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #ffb441;
      img {
        width: 0.32rem;
        height: 0.32rem;
      }
    }
  }
}
.wrap {
  background: #f4f5f4;
  min-height: 100vh;
}

.nothing {
  width: 100%;
  background: #ffffff;
  min-height: 260px;
  box-sizing: border-box;
  text-align: center;
  img {
    width: 100px;
    display: inline-block;
    margin: 80px auto 0px;
    /*width: 100%;*/
  }
  div {
    font-size: 16px;
    color: #999999;
    text-align: center;
  }
}
.banner {
  width: 7.5rem;
}
.container {
  margin-bottom: 0.98rem;
  .container_item {
    background: #ffffff;
    margin-bottom: 0.21rem;
    padding-left: 0.3rem;
    box-sizing: border-box;
    border-bottom: 1px solid #e6e6e6;
    .item_title {
      padding-right: 0.29rem;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
      padding-top: 0.16rem;
      padding-bottom: 0.21rem;
      .title_name {
        font-size: 0.26rem;
        color: #666666;
      }
      .title_time {
        font-size: 0.24rem;
        color: #999999;
      }
    }

    .con {
      /*border-bottom: 1px solid #E6E6E6;*/
      box-sizing: border-box;
      padding-bottom: 0.16rem;
      height: 1.77rem;
      display: flex;
      align-items: flex-start;
      flex-shrink: 0;
      .con_right {
        /*height: 1.62rem;*/
        display: flex;
        flex-direction: column;
        justify-content: space-between;
      }
      .con_images {
        width: 2.84rem;
        height: 1.6rem;
        margin-right: 0.22rem;
      }
      .con_title {
        width: 3.83rem;
        font-size: 0.34rem;
        color: #333333;
        line-height: 0.42rem;
        display: -webkit-box;
        -webkit-box-orient: vertical; /*设置弹性盒模型子元素的排列方式*/
        -webkit-line-clamp: 2; /*限制文本行数*/
        font-weight: bold;
        /*white-space: nowrap;      !*超出的空白区域不换行*!*/
        overflow: hidden; /*超出隐藏*/
        text-overflow: ellipsis; /*文本超出显示省略号*/

        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        /* autoprefixer: off */
        -webkit-box-orient: vertical;
        /* autoprefixer: on */
        -webkit-line-clamp: 2;
      }
    }
    .con_author {
      /*margin-top: 0.68rem;*/
      color: #333333;
      font-size: 0.26rem;
    }
    .con_org {
      font-size: 0.26rem;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      width: 3.83rem;
    }
  }
  .type_title {
    padding-left: 0.33rem;
    box-sizing: border-box;
    border-bottom: 1px solid #e6e6e6;
    margin-top: 0.2rem;
  }
  .last {
    span:nth-of-type(1) {
      font-size: 0.26rem;
    }
  }
  .last,
  .type_title {
    display: flex;
    height: 0.8rem;
    justify-content: space-between;
    padding-right: 0.29rem;
    align-items: center;
    background: #ffffff;
    button {
      width: 1.4rem;
      height: 0.5rem;
      background: linear-gradient(
        0deg,
        rgba(9, 131, 255, 1) 0%,
        rgba(33, 175, 255, 1) 100%
      );
      border-radius: 25px;
      font-size: 0.26rem;
      color: #ffffff;
      border: none;
      outline: none;
    }
  }
  .footer_type {
    font-size: 0.26rem;
    color: #ffb400;
  }
  .textColor {
    color: #2bcf4a;
  }
  .live_type {
    font-size: 0.34rem;
    font-weight: bold;
    color: #007eff;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/live/alllives.vue